import { render, staticRenderFns } from "./InformeInstructores.vue?vue&type=template&id=783f280e"
import script from "./InformeInstructores.vue?vue&type=script&lang=js"
export * from "./InformeInstructores.vue?vue&type=script&lang=js"
import style0 from "./InformeInstructores.vue?vue&type=style&index=0&id=783f280e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports